import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "https://modularobjects.com";

const API = `${API_BASE}/marketing/api/erp/inventory`;

function authHeader(token) {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

export async function fetchInventoryBalances(token, params = {}) {
  const res = await axios.get(`${API}/balances`, {
    ...authHeader(token),
    params,
  });
  return res.data;
}

export async function fetchInventoryLedger(token, params = {}) {
  const res = await axios.get(`${API}/ledger`, {
    ...authHeader(token),
    params,
  });
  return res.data;
}

export async function fetchLowStockItems(token, params = {}) {
  const res = await axios.get(`${API}/low-stock`, {
    ...authHeader(token),
    params,
  });
  return res.data;
}